import { Gift } from "lucide-react";

/**
 * BattleGiftCta — Feb 2026: during an active 1v1 Battle, the "Send Gift"
 * control moves from the right-side rail to a prominent bottom-center pill
 * so that a viewer's dominant thumb reaches it naturally as the primary
 * battle action. Gift LOGIC is unchanged — this only changes affordance:
 * clicking still opens the same GiftPicker sheet via the same onOpen
 * callback wired in LiveRoom.jsx.
 *
 * Positioning rules:
 *   - `bottom` = safe-area + 80px → sits above the chat composer
 *     (which lives at safe + 16 with ~40px height) with a comfortable
 *     margin so nothing overlaps the input or Send button
 *   - `left-1/2` + `-translate-x-1/2` → true horizontal center
 *   - `z-30` → same layer as the composer and top bar; below the
 *     Radix Sheet portals (z-[120]) so opening the wrench/gift picker
 *     still stacks above this CTA
 *   - Pointer-events isolated so the surrounding transparent wrapper
 *     doesn't intercept vertical / horizontal swipe surf gestures
 *
 * Only rendered when: `battleActive && !isHost && onOpenGift` (host
 * can't gift themselves; guard mirrors the existing anti-self-gifting
 * behavior in LiveRoomActionRail).
 */
export default function BattleGiftCta({ onOpenGift }) {
  if (!onOpenGift) return null;
  return (
    <div
      className="pointer-events-none absolute left-1/2 -translate-x-1/2 z-30"
      style={{ bottom: "calc(env(safe-area-inset-bottom, 0px) + 80px)" }}
    >
      <button
        type="button"
        data-testid="battle-gift-cta"
        onClick={onOpenGift}
        className="pointer-events-auto flex items-center gap-2 bg-gradient-to-br from-yellow-400 to-amber-500 hover:from-yellow-300 hover:to-amber-400 text-black font-semibold text-sm rounded-full pl-4 pr-5 py-3 shadow-lg shadow-yellow-500/40 border border-yellow-200/40 active:scale-95 transition"
        aria-label="Send a battle gift"
      >
        <Gift size={18} />
        <span>Send Gift</span>
      </button>
    </div>
  );
}
